import axios from "axios";
import { CHECKOUT_BASE } from "../../config/env";
import api from "../../services/api";
export const FETCH_CHECKOUT_FULFILLED = "FETCH_CHECKOUT_FULFILLED";
export const FETCH_CHECKOUT_REJECTED = "FETCH_CHECKOUT_REJECTED";
export const FETCH_CHECKOUT_PENDING = "FETCH_CHECKOUT_PENDING";
export const RESET_CHECKOUT = "RESET_CHECKOUT";

export function checkout(paymentTypeId, paymentInfo, successAction, failAction, externalId) {
  return (dispatch) => {
    dispatch({ type: FETCH_CHECKOUT_PENDING });
    api.post("/gate/cart/checkout", { paymentTypeId, paymentInfo, successAction, failAction, externalId})
      .then(response => {
        dispatch({
          type: FETCH_CHECKOUT_FULFILLED,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_CHECKOUT_REJECTED,
          payload: error,
        });
      });
  };
}

export function resetCheckout() {
  return (dispatch) => {
    dispatch({
      type: RESET_CHECKOUT,
    });
  };
}